import React from 'react';

import { OperationType } from '@api/ecommerce-xp';
import { useDidMount, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { rem } from '@helpers';
import { useValuesByScreenSize } from '@hooks';
import { useFetchClickToCallAllInternationalDialingPhoneCodes, useFetchRetrieveCompany } from '@services';
import { useServiceResponse, useUserInput } from '@store';

export interface CorporateFormProps {
	title: string;
	pagePadding: string;
}
interface CorporateDataOutput extends CorporateFormProps {
	isLoading: boolean | undefined;
}

export const useCorporateDataHelper = (): CorporateDataOutput => {
	const t = useTranslation();
	const { fetch: retrieveCompany } = useFetchRetrieveCompany();
	const { fetch: retrieveCountries } = useFetchClickToCallAllInternationalDialingPhoneCodes();
	const { clickToCallAllInternationalDialingPhoneCodes, retrieveCompany: retrieveCompanyResponse } =
		useServiceResponse();
	const { selectedAccount } = useUserInput();

	const pagePadding = useValuesByScreenSize(rem(56, 106, 222, 106), rem(56, 48, 222, 48));

	const isLoading = React.useMemo(() => {
		return retrieveCompanyResponse !== undefined && clickToCallAllInternationalDialingPhoneCodes !== undefined
			? false
			: true;
	}, [clickToCallAllInternationalDialingPhoneCodes, retrieveCompanyResponse]);

	useDidMount(() => {
		if (clickToCallAllInternationalDialingPhoneCodes === undefined) {
			retrieveCountries({ operationType: OperationType.CODES_MB_WAY });
		}
		if (retrieveCompanyResponse === undefined) {
			retrieveCompany({ accountId: selectedAccount?.account.id, cisNumber: selectedAccount?.companyCis });
		}
	});

	const title = t('placeholders.corporateData.title');

	return {
		title,
		pagePadding,
		isLoading,
	};
};
